import React from 'react';
import Banner from '../Banner/Banner';
import ServicesDemo from '../ServicesDemo/ServicesDemo';

const Home = () => {
	return (
		<div className='pb-10'>
			<Banner />
			<ServicesDemo />
		</div>
	);
};

export default Home;
